export default __webpack_public_path__ + "static/media/icon_setting.8ab5dd51.svg";